import { render, staticRenderFns } from "./CrudStore.vue?vue&type=template&id=6646becc&scoped=true"
import script from "./CrudStore.vue?vue&type=script&lang=js"
export * from "./CrudStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646becc",
  null
  
)

export default component.exports